import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { TerroristOrganization, ListResponse } from '@/types';
import { Pagination } from '@/components';
import theme from '@/theme';
import { EditFlat, TrashFlat } from '@/assets/icons';

import { UpdateTerroristOrganization, DeleteTerroristOrganization } from '../components';

export interface TerroristOrganizationListProps {
  list?: ListResponse<TerroristOrganization>;
  page: number;
  onChangePage(page: number): void;
}

const TerroristOrganizationsTable: React.FC<TerroristOrganizationListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentTerroristOrganization, setCurrentTerroristOrganization] = useState<TerroristOrganization | null>(null);

  function openUpdateModal(terroristOrganization: TerroristOrganization) {
    setCurrentTerroristOrganization(terroristOrganization);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(terroristOrganization: TerroristOrganization) {
    setCurrentTerroristOrganization(terroristOrganization);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Наименование</TableCell>
                <TableCell>Наименование (англ.)</TableCell>
                <TableCell>Комментарий</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((terroristOrganization) => {
                const { name, note, id } = terroristOrganization;

                return (
                  <TableRow key={id}>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(terroristOrganization)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(terroristOrganization)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>

                    <TableCell title={name.ru ?? '—'}>{name.ru ?? '—'}</TableCell>
                    <TableCell title={name.en ?? '—'}>{name.en ?? '—'}</TableCell>
                    <TableCell title={note ?? '—'}>{note ?? '—'}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateTerroristOrganization
        terroristOrganization={currentTerroristOrganization!}
        open={updateModalOpened}
        onClose={() => setOpenedUpdateModal(false)}
      />
      <DeleteTerroristOrganization
        terroristOrganization={currentTerroristOrganization!}
        open={deleteModalOpened}
        onClose={() => setOpenedDeleteModal(false)}
      />
    </>
  );
};

export default TerroristOrganizationsTable;
